// One-tap demo scenarios. Fields map directly to the appraisal form state.
export const SCENARIOS = [
  {
    id: "tesla-ev",
    badge: "EV · Structural",
    year: 2023, make: "Tesla", model: "Model Y", trim: "Long Range AWD",
    vin: "7SAYGDEE8PF123456", mileage: 18500, vehicle_type: "Electric",
    location: "San Jose, CA", state: "CA", condition: "Good",
    damage_severity: "Major", repair_cost: 11200,
    structural_damage: true, airbag_deployed: false,
    damage_description: "Rear body panel pull, tailgate replaced, sensor recalibration.",
    owner_name: "Alex Morgan", claim_number: "CLM-8849201", insurance_company: "State Farm",
  },
  {
    id: "bmw-lux",
    badge: "Luxury · Airbag",
    year: 2022, make: "BMW", model: "M340i", trim: "xDrive",
    vin: "WBA5R7C50NFH12345", mileage: 27400, vehicle_type: "Gas",
    location: "Miami, FL", state: "FL", condition: "Good",
    damage_severity: "Severe", repair_cost: 15600,
    structural_damage: true, airbag_deployed: true,
    damage_description: "Front-end collision, driver & curtain airbags deployed, frame rail repair.",
    owner_name: "Jordan Lee", claim_number: "CLM-4471902", insurance_company: "GEICO",
  },
  {
    id: "honda-std",
    badge: "Standard · Moderate",
    year: 2021, make: "Honda", model: "Accord", trim: "Sport",
    vin: "1HGCV1F30MA123456", mileage: 42000, vehicle_type: "Gas",
    location: "Austin, TX", state: "TX", condition: "Good",
    damage_severity: "Moderate", repair_cost: 6200,
    structural_damage: false, airbag_deployed: false,
    damage_description: "Side collision, two doors and quarter panel replaced.",
    owner_name: "Sam Rivera", claim_number: "CLM-2298104", insurance_company: "Progressive",
  },
  {
    id: "ford-truck",
    badge: "Truck · Frame",
    year: 2020, make: "Ford", model: "F-150", trim: "Lariat",
    vin: "1FTEW1EP5LFA12345", mileage: 61000, vehicle_type: "Gas",
    location: "Denver, CO", state: "CO", condition: "Fair",
    damage_severity: "Major", repair_cost: 9800,
    structural_damage: true, airbag_deployed: false,
    damage_description: "Rear frame section replaced after tow-hitch impact.",
    owner_name: "Casey Brooks", claim_number: "CLM-6610233", insurance_company: "Allstate",
  },
];
